import { Fragment, useState } from "react";
import AlbumsCard from "../../AlbumsCard";
import PhotosCard from "../../PhotosCard";
import "./OrganizationPhotos.css";
import {
  ORGANIZATION_ALBUMS,
  ORGANIZATION_PHOTOS,
} from "../../../api/organization";
import { gql } from "@apollo/client";
import Album from "../../../mobileComponents/Album";

export default function OrganizationPhotos({
  id,
  organization,
  canManagePage,
}) {
  const [selectedAlbum, setSelectedAlbum] = useState("");
  const [sportsFilter] = useState([]);
  const [teamsFilter] = useState([]);
  const [eventsFilter] = useState([]);
  return (
    <div className="organization-photos-mobile">
      {selectedAlbum ? (
        <Album
          id={selectedAlbum}
          dismiss={() => {
            setSelectedAlbum("");
          }}
        />
      ) : (
        <Fragment>
          <AlbumsCard
            query={ORGANIZATION_ALBUMS}
            vars={{ id, take: 2 }}
            getAlbums={(data) => data?.organization?.mediaSets || []}
            totalAlbums={(data) => data?.organization?.albumsCount || 0}
            noData={`No albums tagged with ${organization.name} yet.`}
            setSelectedAlbum={setSelectedAlbum}
            filters={{ sportsFilter, teamsFilter, eventsFilter }}
            processFilters={(filters) => {
              return {
                filters: {
                  sports: sportsFilter,
                  teams: teamsFilter,
                  events: eventsFilter,
                },
              };
            }}
            addAlbum={
              canManagePage
                ? {
                    sourceId: id,
                    sourceType: "organization",
                    onAddAlbum: (cache, { data: { createMediaSet } }) => {
                      cache.modify({
                        id: cache.identify(organization),
                        fields: {
                          mediaSets(existingMediaRefs, { readField }) {
                            const newMediasetRef = cache.writeFragment({
                              data: createMediaSet,
                              fragment: gql`
                                fragment NewMediaSet on MediaSet {
                                  id
                                  name
                                  preview {
                                    id
                                    filename
                                  }
                                  source {
                                    id
                                    fixture {
                                      id
                                      scheduledStart
                                      roles(
                                        where: { type: { name: "PARTICIPANT" } }
                                      ) {
                                        id
                                        organization {
                                          id
                                          name
                                        }
                                        profile {
                                          id
                                          name
                                        }
                                      }
                                    }
                                  }
                                }
                              `,
                            });

                            // Quick safety check - if the new comment is already
                            // present in the cache, we don't need to add it again.
                            if (
                              existingMediaRefs.some(
                                (ref) =>
                                  readField("id", ref) === createMediaSet.id
                              )
                            ) {
                              return existingMediaRefs;
                            }

                            return [newMediasetRef, ...existingMediaRefs];

                            // const newMediaSets = [
                            //   createMediaSet,
                            //   ...existingMediaRefs,
                            // ];
                            // console.log("new Media Sets:", newMediaSets);
                            // return newMediaSets;
                          },
                        },
                      });
                    },
                  }
                : false
            }
          />

          <PhotosCard
            query={ORGANIZATION_PHOTOS}
            vars={{ id, take: 16 }}
            getPhotos={(data) => data?.organization?.media || []}
            totalPhotos={(data) => data?.organization?.photosCount || 0}
            noData={`No tagged photos of ${organization.name} yet.`}
            filters={{ sportsFilter, teamsFilter, eventsFilter }}
            processFilters={(filters) => {
              return {
                filters: {
                  sports: sportsFilter,
                  teams: teamsFilter,
                  events: eventsFilter,
                },
              };
            }}
            onDelete={(cache, { data: { deleteMedia } }) => {
              cache.modify({
                id: cache.identify(organization),
                fields: {
                  media(existingMediaRefs, { readField }) {
                    return existingMediaRefs.filter(
                      (mediaRef) => deleteMedia.id !== readField("id", mediaRef)
                    );
                  },
                },
              });
            }}
            addPhoto={
              canManagePage
                ? {
                    sourceId: id,
                    sourceType: "organization",
                    onAddPhoto: (cache, createMedia) => {
                      cache.modify({
                        id: cache.identify(organization),
                        fields: {
                          media(existingMediaRefs, { readField }) {
                            const newMediaRef = cache.writeFragment({
                              data: createMedia.media,
                              fragment: gql`
                                fragment NewMedia on Media {
                                  id
                                  createdAt
                                  type
                                  subtype
                                  isExternal
                                  filename
                                  public
                                  aspectRatio
                                  canManageMedia
                                }
                              `,
                            });

                            // Quick safety check - if the new comment is already
                            // present in the cache, we don't need to add it again.
                            if (
                              existingMediaRefs.some(
                                (ref) =>
                                  readField("id", ref) === createMedia.media.id
                              )
                            ) {
                              return existingMediaRefs;
                            }

                            return [newMediaRef, ...existingMediaRefs];

                            // const newMediaSets = [
                            //   createMediaSet,
                            //   ...existingMediaRefs,
                            // ];
                            // console.log("new Media Sets:", newMediaSets);
                            // return newMediaSets;
                          },
                        },
                      });
                      // setAppState({ modal: false });
                    },
                  }
                : false
            }
          />
        </Fragment>
      )}
    </div>
  );
}
